export const WORKFLOW_STATUS_DONE = "done";
export const WORKFLOW_STATUS_RUNNING = "running";
export const WORKFLOW_STATUS_PENDING = "pending";
export const WORKFLOW_STATUS_PAUSED = "paused";
export const WORKFLOW_STATUS_SKIPPED = "skipped";

export const WORKFLOW_RUN_STATUS_COMPLETED = "completed";
export const WORKFLOW_RUN_STATUS_IN_PROGRESS = "in-progress";
export const WORKFLOW_RUN_STATUS_FAILED = "failed";
export const WORKFLOW_RUN_STATUS_CANCELED = "canceled";
export const WORKFLOW_RUN_STATUS_NEVER_RUN = "never-run";

export const ASSIGNEE_TYPE_AGENT = "agent";
export const ASSIGNEE_TYPE_COLLABORATOR = "collaborator";

export const BUILDER_MODE_NEW = "new";
export const BUILDER_MODE_EDIT = "edit";
export const BUILDER_MODE_PREVIEW = "preview";

export const DEFAULT_BYPASS_AFTER_MINUTES = 30;

export const FALLBACK_AGENT_BADGE_COLOR_TOKEN = "subtle";
export const FALLBACK_BUBBLE_COLOR_TOKEN = "light";

export const AGENT_TYPE_RESEARCHER = "researcher";
export const AGENT_TYPE_WRITER = "writer";
export const AGENT_TYPE_EDITOR = "editor";
export const AGENT_TYPE_ANALYST = "analyst";
export const AGENT_TYPE_VIDEO_EDITOR = "video_editor";
export const AGENT_TYPE_GRAPHICS_DESIGNER = "graphics_designer";
export const AGENT_TYPE_WEB_DESIGNER = "web_designer";
export const AGENT_TYPE_APP_DESIGNER = "app_designer";
export const AGENT_TYPE_SOCIAL_MEDIA = "social_media";

export const AI_AGENT_ENTITY_TYPE = "myOrganizationAiAgents";
export const COLLABORATOR_ENTITY_TYPE = "myPublicationCollaborators";
export const WORKFLOW_ENTITY_TYPE = "myPublicationWorkflows";
export const AI_AGENT_FEED_SOURCE = "MyOrganizationAiAgentsFeedSource";
export const COLLABORATOR_FEED_SOURCE = "MyPublicationCollaboratorsFeedSource";

export const STEP_OUTPUT_PREVIEW_MAX_LENGTH = 600;

export const PINTEREST_PREVIEW_IMAGE_URL = "https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=560&h=740&fit=crop&auto=format&q=80";
export const TIKTOK_PREVIEW_IMAGE_URL = "https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=560&h=1000&fit=crop&auto=format&q=80";
export const YOUTUBE_PREVIEW_THUMBNAIL_URL = "https://images.unsplash.com/photo-1611162616475-46b635cb6868?w=760&h=428&fit=crop&auto=format&q=80";

export const INPUT_FILE_TYPES_BY_AGENT_TYPE = {
  [AGENT_TYPE_VIDEO_EDITOR]: ["video/*"],
  [AGENT_TYPE_GRAPHICS_DESIGNER]: ["image/*", "application/pdf"],
};

export const BYTES_PER_MEGABYTE = 1024 * 1024;
export const BYTES_PER_GIGABYTE = 1024 * 1024 * 1024;

export const GEMINI_VIDEO_MAX_BYTES = 2147483648;
export const GEMINI_VIDEO_MAX_DURATION_SECONDS = 3600;
export const GEMINI_VIDEO_ALLOWED_MIME_TYPES = [
  "video/mp4",
  "video/mpeg",
  "video/quicktime",
  "video/avi",
  "video/x-flv",
  "video/mpg",
  "video/webm",
  "video/wmv",
  "video/3gpp",
];

export const INPUT_FILE_KIND_ICON = {
  video: "video",
  image: "image",
  audio: "music",
  document: "file",
};

export const VIDEO_PLAYBACK_STATUS_READY = "ready";

export const AGENT_OUTPUT_FIELDS = [
  "keyFacts",
  "sources",
  "notes",
  "title",
  "bodyText",
  "suggestedTags",
  "changeNotes",
  "findings",
  "recommendations",
  "concept",
  "palette",
  "elements",
  "referenceImages",
  "sections",
  "screens",
  "navigation",
  "platforms",
  "clips",
  "transitions",
  "storyId",
  "postText",
];

const COLLABORATOR_PALETTE = [
  "#f97316",
  "#06b6d4",
  "#a855f7",
  "#ec4899",
  "#14b8a6",
  "#3b82f6",
  "#84cc16",
  "#e11d48",
];

export function collaboratorColorFor(id) {
  const idx = Math.abs(Number(id) || 0) % COLLABORATOR_PALETTE.length;
  return COLLABORATOR_PALETTE[idx];
}

export function collaboratorInitials(name) {
  if (!name) {
    return "?";
  }
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
